module.exports = __webpack_public_path__ + "static/githubeducation-7f9678ca67362b65d9094019c3698c3f.png";